import { render, staticRenderFns } from "./SearchCTA.vue?vue&type=template&id=8983b522&"
import script from "./SearchCTA.vue?vue&type=script&lang=js&"
export * from "./SearchCTA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports